import { render, staticRenderFns } from "./Mybonehealth.vue?vue&type=template&id=2b57dcb1&scoped=true&"
import script from "./Mybonehealth.vue?vue&type=script&lang=js&"
export * from "./Mybonehealth.vue?vue&type=script&lang=js&"
import style0 from "./Mybonehealth.vue?vue&type=style&index=0&id=2b57dcb1&scoped=true&lang=css&"
import style1 from "./Mybonehealth.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57dcb1",
  null
  
)

export default component.exports